/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Start_WorkoutInputs */

const en_features_start_workout = /** @type {(inputs: Features_Start_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start workout`)
};

const pl_features_start_workout = /** @type {(inputs: Features_Start_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij trening`)
};

/**
* | output |
* | --- |
* | "Start workout" |
*
* @param {Features_Start_WorkoutInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_start_workout = /** @type {((inputs?: Features_Start_WorkoutInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Start_WorkoutInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_start_workout(inputs)
	return en_features_start_workout(inputs)
});